// Choix de la cible de la prise en main : console (écran physique, par défaut)
// ou une des sessions ouvertes (usager, type, état). Proposé sur un serveur,
// quand plusieurs sessions sont ouvertes ou qu'une session RDP existe.

import { useState } from 'react';
import { X, Monitor, User } from 'lucide-react';

export function RemoteSessionModal({ targets, computerName, onChoose, onClose, busy }) {
  const [choice, setChoice] = useState('console');
  const sessions = targets?.sessions || [];

  const submit = () => {
    if (choice === 'console') return onChoose({ target: 'console' });
    const s = sessions.find((x) => String(x.windowsSessionId) === choice);
    if (s) onChoose({ target: 'session', windowsSessionId: s.windowsSessionId, username: s.username });
  };

  const row = (value, icon, title, sub) => (
    <label
      key={value}
      className={`flex items-start gap-3 p-3 rounded-lg border cursor-pointer ${
        choice === value ? 'border-blue-500/60 bg-blue-500/10' : 'border-rule bg-app hover:bg-rule'
      }`}
    >
      <input type="radio" name="remote-target" className="mt-1" checked={choice === value} onChange={() => setChoice(value)} />
      <span className="text-muted mt-0.5">{icon}</span>
      <span className="flex-1 min-w-0">
        <span className="block text-[13px] font-semibold text-fg">{title}</span>
        <span className="block text-[11px] text-muted-2">{sub}</span>
      </span>
    </label>
  );

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-[1000] p-4">
      <div className="bg-card border border-rule rounded-2xl w-[480px] max-w-full max-h-[90vh] shadow-2xl flex flex-col overflow-hidden">
        <div className="px-6 pt-6 pb-3 flex items-center justify-between">
          <div>
            <h2 className="text-base font-bold text-fg">Contrôle à distance</h2>
            <div className="text-xs text-muted-2">{computerName}</div>
          </div>
          <button onClick={onClose} className="bg-transparent border-none text-muted cursor-pointer" aria-label="Fermer">
            <X size={18} />
          </button>
        </div>
        <div className="px-6 pb-4 flex flex-col gap-2 overflow-auto">
          {row('console', <Monitor size={16} strokeWidth={1.75} />, 'Console (écran physique)', 'Ce qui s’affiche sur l’écran du poste, y compris l’écran de connexion.')}
          {sessions.map((s) =>
            row(
              String(s.windowsSessionId),
              <User size={16} strokeWidth={1.75} />,
              s.username || 'Session ' + s.windowsSessionId,
              [s.sessionType === 'RDP' ? 'Bureau à distance (RDP)' : 'Console', s.state, 'session ' + s.windowsSessionId]
                .filter(Boolean)
                .join(' · '),
            ),
          )}
          {sessions.length === 0 && <div className="text-xs text-muted-2">Aucune session ouverte au dernier inventaire.</div>}
          {targets?.unattended === false && (
            <div className="text-[11px] text-amber-300 mt-1">Accès non supervisé désactivé : l’usager devra accepter.</div>
          )}
        </div>
        <div className="px-6 py-4 border-t border-rule flex justify-end gap-2">
          <button onClick={onClose} className="bg-rule border border-rule-3 rounded-lg px-4 py-2 text-xs font-semibold text-muted cursor-pointer">
            Annuler
          </button>
          <button
            onClick={submit}
            disabled={busy}
            className="bg-blue-500 border-none rounded-lg px-4 py-2 text-xs font-semibold text-white cursor-pointer disabled:opacity-50"
          >
            Se connecter
          </button>
        </div>
      </div>
    </div>
  );
}
